<!-- Header -->
<header>
  <div class="header-container">
    <img class="logo" src="assets/images/lex-z_logo.png" alt="Lex-Z" />
    <nav>
      <a href="https://lex-z.ai/">Find Lawyers</a>
      <a href="https://lex-z.ai/video-consultation/">Video Consultation</a>
      <a href="https://lex-z.ai/credential-validation/">Credential Validation</a>
      <a href="https://lex-z.ai/products/">Products</a>
      <a href="https://lex-z.ai/blogs/">Resources</a>
      <ng-container *ngIf="isLoggedIn; else loginBtn">
        <a href="javascript:void(0)" class="my-appointments-btn" (click)="router.navigate(['/consumer/appointments'])">
          My Appointments
        </a>
      </ng-container>
      <ng-template #loginBtn>
        <a href="javascript:void(0)" class="login-signup-btn" (click)="router.navigate(['/consumer/login'])">Login / Signup</a>
      </ng-template>
    </nav>
    <button class="mobile-menu-btn" (click)="mobileMenuOpen = !mobileMenuOpen">☰</button>
  </div>
  <div class="mobile-menu" [class.active]="mobileMenuOpen">
    <nav class="mobile-nav">
      <a href="https://lex-z.ai/">Find Lawyers</a>
      <a href="https://lex-z.ai/video-consultation/">Video Consultation</a>
      <a href="https://lex-z.ai/credential-validation/">Credential Validation</a>
      <a href="https://lex-z.ai/products/">Products</a>
      <a href="https://lex-z.ai/blogs/">Resources</a>
      <ng-container *ngIf="isLoggedIn; else mobileLoginBtn">
        <a href="javascript:void(0)" class="my-appointments-btn" (click)="mobileMenuOpen = false; router.navigate(['/consumer/appointments'])">My Appointments</a>
      </ng-container>
      <ng-template #mobileLoginBtn>
        <a href="javascript:void(0)" class="login-signup-btn" (click)="mobileMenuOpen = false; router.navigate(['/consumer/login'])">Login / Signup</a>
      </ng-template>
    </nav>
  </div>
</header>

<!-- Loading overlay -->
<div class="upload-overlay" *ngIf="isLoading">
  <div class="logo-spinner">
    <img src="assets/logo.svg" alt="Loading..." />
  </div>
</div>

<!-- Firm not found -->
<div class="not-found-container" *ngIf="!isLoading && !firm">
  <div class="not-found-icon">🏛️</div>
  <h2>Firm Not Found</h2>
  <p>We couldn't load the firm details. The link may be invalid or the firm may no longer be listed.</p>
  <button class="back-btn-standalone" (click)="goBack()">← Back to Results</button>
</div>

<!-- Main page -->
<div class="firm-details-page" *ngIf="!isLoading && firm">

  <!-- ── Outer page wrapper with 2-column layout ── -->
  <div class="fd-page-outer">

    <!-- ══════════════════════════════════════════
         LEFT COLUMN: profile card + tabs + content
         ══════════════════════════════════════════ -->
    <div class="fd-main-col">

      <!-- Profile Card + Tabs -->
      <div class="page-container">

        <!-- <button class="back-btn" (click)="goBack()">
          <i class="bi bi-arrow-left"></i> Back to results
        </button> -->

        <div class="profile-card">
          <div class="profile-card-top">
            <div class="profile-pic-container">
              <ng-container *ngIf="firm.avatar && firm.avatar !== ''; else heroFallback">
                <img [src]="firm.avatar" [alt]="firm.name + ' Profile Picture'" class="profile-pic" loading="lazy" />
              </ng-container>
              <ng-template #heroFallback>
                <div class="profile-placeholder firm-placeholder"><i class="bi bi-building"></i></div>
              </ng-template>
            </div>

            <div class="profile-details">
              <div class="firm-name-row">
                <h2>{{ firm.name }}</h2>
                <span class="firm-type-badge">LAW FIRM</span>
              </div>
              <div class="firm-hero-specs" *ngIf="firm.specializations?.length">
                <span class="spec-text">{{ getSpecText(firm.specializations) }}</span>
              </div>
              <div class="firm-hero-meta">
                <span *ngIf="firm.address" class="hero-meta-item">
                  <i class="bi bi-geo-alt"></i> {{ getFullAddress(firm.address) }}
                </span>
                <span *ngIf="!firm.address && firm.location" class="hero-meta-item">
                  <i class="bi bi-geo-alt"></i> {{ firm.location }}
                </span>
                <span *ngIf="firm.yearsOfExperience" class="hero-meta-item hero-meta-separator">
                   <i class="bi bi-briefcase"></i> {{ firm.yearsOfExperience }} years experience
                </span>
                <span *ngIf="firmLawyers.length > 0" class="hero-meta-item hero-meta-separator">
                  <i class="bi bi-people"></i>
                  <a class="lawyers-count-link" (click)="bookAppointmentForFirm()">
                    {{ firmLawyers.length }} lawyer{{ firmLawyers.length !== 1 ? 's' : '' }}
                  </a>
                </span>
                <span *ngIf="firmLawyers.length === 0 && firm.memberCount" class="hero-meta-item hero-meta-separator">
                  <i class="bi bi-people"></i>
                  <a class="lawyers-count-link" (click)="bookAppointmentForFirm()">
                    {{ firm.memberCount }} lawyer{{ firm.memberCount !== 1 ? 's' : '' }}
                  </a>
                </span>
              </div>
            </div>

            <div class="firm-hero-cta">
              <span class="hero-availability-pill"
                [ngStyle]="firm.availabilityStyle"
                [ngClass]="{'badge-unavailable': firm.availability === 'Unavailable'}">
                {{ firm.availability }}
              </span>
              <button class="hero-book-btn"
                [disabled]="firm.availability === 'Unavailable'"
                (click)="bookAppointmentForFirm()">
                Book Appointment
              </button>
              <!-- <p class="cta-subtext" *ngIf="firm.memberCount">
                {{ firm.memberCount }} lawyer{{ firm.memberCount !== 1 ? 's' : '' }} available
              </p> -->
            </div>
          </div>
        </div>

      </div><!-- /page-container -->

      <!-- Tabs + Content unified card -->
      <div class="tabs-content-card">

        <!-- Tabs -->
        <div class="tabs-wrapper" #tabsBar>
          <div class="tabs-container">
            <button class="tab-btn" *ngIf="firm.bio" [class.active]="activeTab === 'about'" (click)="switchTab('about')">
              Overview
            </button>
            <button class="tab-btn" [class.active]="activeTab === 'lawyers'" (click)="switchTab('lawyers')">
              Lawyers
              <span class="tab-count" *ngIf="firmLawyers.length > 0">{{ firmLawyers.length }}</span>
            </button>
          </div>
        </div>

        <!-- Tab Content -->
        <div class="tab-content-area">

    <!-- ══════════════════════
         TAB 1: About Firm
         ══════════════════════ -->
    <div class="tab-panel" *ngIf="activeTab === 'about'">
      <div class="about-grid">

        <!-- About Firm -->
        <div class="about-card">
          <h3 class="about-card-title"><i class="bi bi-info-circle"></i> About Firm</h3>
          <p class="about-description" *ngIf="firm.bio; else noDescription">{{ firm.bio }}</p>
          <ng-template #noDescription>
            <p class="about-description muted">
              {{ firm.name }} is a registered law firm providing expert legal services across multiple practice areas.
              With a dedicated team of qualified lawyers, the firm is committed to delivering personalised and effective
              legal representation to every client.
            </p>
          </ng-template>
        </div>

        <!-- Office Address -->
        <div class="about-card">
          <h3 class="about-card-title"><i class="bi bi-geo-alt"></i> Office Address</h3>
          <div class="about-address" *ngIf="firm.address; else noAddress">
            <div class="address-line" *ngIf="firm.address.street">
              <i class="bi bi-signpost"></i> {{ firm.address.street }}
            </div>
            <div class="address-line" *ngIf="firm.address.area">
              <i class="bi bi-map"></i> {{ firm.address.area }}
            </div>
            <div class="address-line" *ngIf="firm.address.city || firm.address.state || firm.address.postcode">
              <i class="bi bi-pin-map"></i> {{ getFormattedAddress(firm.address) }}
            </div>
            <div class="address-line" *ngIf="firm.address.country">
              <i class="bi bi-globe"></i> {{ firm.address.country }}
            </div>
          </div>
          <ng-template #noAddress>
            <div class="about-address">
              <div class="address-line"><i class="bi bi-pin-map"></i> {{ firm.location || 'Address not available' }}</div>
            </div>
          </ng-template>
        </div>

      </div><!-- /about-grid -->

      <!-- Practice Areas — full-width row below About/Address, like bookslot's "Practicing At" -->
      <div class="about-card about-block-full">
        <h3 class="about-card-title"><i class="bi bi-briefcase"></i> Practice Areas</h3>
        <div class="spec-grid" *ngIf="firm.specializations?.length; else noSpecs">
          <span class="spec-chip-large" *ngFor="let s of firm.specializations">{{ formatSpec(s) }}</span>
        </div>
        <ng-template #noSpecs>
          <p class="muted">Practice areas not specified.</p>
        </ng-template>
      </div>

      <!-- <div class="about-card stat-row-card" *ngIf="firm.memberCount || firm.specializations?.length">
        <div class="stat-item" *ngIf="firm.memberCount">
          <span class="stat-number">{{ firm.memberCount }}</span>
          <span class="stat-label">Lawyers</span>
        </div>
        <div class="stat-item" *ngIf="firm.specializations?.length">
          <span class="stat-number">{{ firm.specializations.length }}</span>
          <span class="stat-label">Practice Areas</span>
        </div>
        <div class="stat-item view-lawyers-stat" (click)="switchTab('lawyers')">
          <span class="stat-number stat-action"><i class="bi bi-arrow-right-circle"></i></span>
          <span class="stat-label">View Lawyers</span>
        </div>
      </div> -->

    </div>
    <!-- /Tab 1 -->

    <!-- ══════════════════════
         TAB 2: Lawyers
         ══════════════════════ -->
    <div class="tab-panel" *ngIf="activeTab === 'lawyers'">

      <!-- Loading -->
      <div class="lawyers-loading" *ngIf="lawyersLoading">
        <div class="spinner"></div>
        <p>Loading lawyers from this firm…</p>
      </div>

      <!-- Error -->
      <div class="lawyers-error" *ngIf="lawyersError && !lawyersLoading">
        <i class="bi bi-exclamation-triangle"></i>
        <p>{{ lawyersError }}</p>
        <button class="retry-btn" (click)="loadFirmLawyers()">
          <i class="bi bi-arrow-clockwise"></i> Retry
        </button>
      </div>

      <!-- Empty -->
      <div class="lawyers-empty" *ngIf="!lawyersLoading && !lawyersError && firmLawyers.length === 0">
        <i class="bi bi-people"></i>
        <h4>No lawyers listed yet</h4>
        <p>This firm currently has no lawyers listed. Please check back later or contact the firm directly.</p>
        <button class="retry-btn" (click)="goBack()">← Back to Search</button>
      </div>

      <!-- Lawyer list -->
      <div class="firm-lawyer-list" *ngIf="!lawyersLoading && !lawyersError && firmLawyers.length > 0">

        <!-- <div class="lawyers-count-bar">
          <span class="lawyers-count-text">
            <i class="bi bi-people-fill"></i>
            {{ firmLawyers.length }} Lawyer{{ firmLawyers.length !== 1 ? 's' : '' }} in this firm
          </span>
        </div> -->

        <ng-container *ngFor="let lawyer of firmLawyers; let i = index">

          <div class="firm-lawyer-card"
               #lawyerCardRef
               [class.expanded]="expandedLawyerIndex === i"
               [class.unavailable]="lawyer.availability === 'Unavailable'">

            <!-- ── Lawyer summary row ── -->
            <div class="flc-main">
              <div class="flc-avatar">
                <ng-container *ngIf="lawyer.avatar && lawyer.avatar !== ''; else flcFallback">
                  <img [src]="lawyer.avatar" [alt]="lawyer.name + ' Profile Picture'" loading="lazy" />
                </ng-container>
                <ng-template #flcFallback>
                  <div class="flc-avatar-placeholder">{{ getInitial(lawyer.name) }}</div>
                </ng-template>
              </div>

              <div class="flc-info">
                <div class="flc-name">{{ lawyer.name }}</div>
                <div class="flc-specialty" *ngIf="lawyer.specialty">{{ lawyer.specialty }}</div>
                <div class="flc-meta">
                  <span *ngIf="lawyer.experience"><i class="bi bi-briefcase"></i> {{ lawyer.experience }} yrs exp</span>
                  <span *ngIf="lawyer.location"><i class="bi bi-geo-alt"></i> {{ lawyer.location }}</span>
                  <span *ngIf="lawyer.languages">
                    <i class="bi bi-translate"></i> {{ lawyer.languages }}
                  </span>
                </div>
                <!-- <div class="flc-languages" *ngIf="lawyer.languages">
                  <i class="bi bi-translate"></i> {{ lawyer.languages }}
                </div> -->
              </div>

              <div class="flc-right">
                <span class="availability-badge"
                  [ngStyle]="lawyer.availabilityStyle"
                  [ngClass]="{'badge-unavailable': lawyer.availability === 'Unavailable'}">
                  {{ lawyer.availability }}
                </span>
                <button class="flc-book-btn"
                  [class.flc-book-btn--collapse]="expandedLawyerIndex === i"
                  [disabled]="lawyer.availability === 'Unavailable'"
                  (click)="toggleSlotExpansion(i, lawyer)">
                  <ng-container *ngIf="expandedLawyerIndex === i; else bookLabel">
                    <i class="bi bi-chevron-up"></i> Hide Profile
                  </ng-container>
                  <ng-template #bookLabel>
                   Book Appointment
                  </ng-template>
                </button>
                <!-- <span class="unavailable-hint" *ngIf="lawyer.availability === 'Unavailable'">
                  Currently unavailable
                </span> -->
              </div>
            </div>

            <!-- ═══════════════════════════════════════════════════════════
                 SELECTED LAWYER — internal Overview | Available Slots tabs.
                 The "Available Slots" panel below reuses the EXACT same
                 markup as bookslot.component so the UI stays 100% consistent
                 across the app — only wrapped so it now renders per internal tab.
                 ═══════════════════════════════════════════════════════════ -->
            <div class="slot-expansion-wrapper" *ngIf="expandedLawyerIndex === i">

              <!-- Internal tabs: Overview | Available Slots -->
              <div class="lawyer-inner-tabs" role="tablist">
                <button type="button"
                  class="lawyer-inner-tab-btn"
                  role="tab"
                  [attr.aria-selected]="lawyerInternalTab === 'overview'"
                  [class.active]="lawyerInternalTab === 'overview'"
                  (click)="switchLawyerTab('overview')">
                  Overview
                </button>
                <button type="button"
                  class="lawyer-inner-tab-btn"
                  role="tab"
                  [attr.aria-selected]="lawyerInternalTab === 'slots'"
                  [class.active]="lawyerInternalTab === 'slots'"
                  (click)="switchLawyerTab('slots')">
                  Available Slots
                </button>
              </div>

              <!-- Shared loading state — same fetch powers both Overview and Slots -->
              <div class="slot-inline-state" *ngIf="slotsLoading">
                <div class="spinner-sm"></div>
                <span>{{ lawyerInternalTab === 'overview' ? 'Loading lawyer details…' : 'Loading available slots…' }}</span>
              </div>

              <!-- Shared error state -->
              <div class="slot-inline-state slot-inline-error" *ngIf="slotsError && !slotsLoading">
                <i class="bi bi-exclamation-circle"></i>
                <span>{{ slotsError }}</span>
              </div>

              <!-- ══════════════ INTERNAL TAB: OVERVIEW ══════════════ -->
              <div class="lawyer-overview-panel"
                   *ngIf="lawyerInternalTab === 'overview' && !slotsLoading && !slotsError && slotData">

                <ng-container *ngIf="!hasNoOverviewData(slotData.profile)">

                  <div class="overview-grid">

                    <!-- About the Lawyer -->
                    <div class="overview-block" *ngIf="slotData.profile?.bio">
                      <h4 class="overview-block-title"><i class="bi bi-person-vcard"></i> About the Lawyer</h4>
                      <p class="overview-text">{{ getTruncatedText(slotData.profile.bio, lawyerAboutExpanded) }}</p>
                      <a *ngIf="isLongText(slotData.profile.bio)"
                        href="javascript:void(0)" class="read-more-link"
                        (click)="lawyerAboutExpanded = !lawyerAboutExpanded">
                        {{ lawyerAboutExpanded ? 'Read less' : 'Read more' }}
                      </a>
                    </div>

                    <!-- Cases Handled -->
                    <div class="overview-block" *ngIf="getLawyerCasesItems(slotData.profile).length">
                      <h4 class="overview-block-title"><i class="bi bi-folder2-open"></i> Cases Handled</h4>
                      <ul class="cases-handled-list">
                        <li class="cases-handled-item" *ngFor="let item of getLawyerCasesItems(slotData.profile); let i = index">
                          <span class="case-bullet"></span>
                          <div class="case-content">
                            <div class="case-title" *ngIf="item.title">{{ item.title }}</div>
                            <p class="overview-text">{{ getTruncatedText(item.description, lawyerCasesExpandedMap[i]) }}</p>
                            <a *ngIf="isLongText(item.description)"
                              href="javascript:void(0)" class="read-more-link"
                              (click)="toggleLawyerCaseExpanded(i)">
                              {{ lawyerCasesExpandedMap[i] ? 'Read less' : 'Read more' }}
                            </a>
                          </div>
                        </li>
                      </ul>
                    </div>

                  </div>
                  <!-- /overview-grid -->

                  <!-- Practicing At — full-width row below About/Cases Handled, exact bookslot.component markup -->
                  <div class="overview-block overview-block-full" *ngIf="getPracticeAt(slotData.profile).length">
                    <h4 class="overview-block-title"><i class="bi bi-bank"></i> Practicing At</h4>
                    <div class="practicing-at-list">
                      <div class="practicing-at-item" *ngFor="let p of getPracticeAt(slotData.profile)">
                        <span class="court-name">{{ p.title }}</span>
                        <span class="court-location" *ngIf="p.subtitle">{{ p.subtitle }}</span>
                      </div>
                    </div>
                  </div>

                </ng-container>

                <!-- Graceful empty state — no bio / practice_at / cases_handled for this lawyer -->
                <div class="lo-empty" *ngIf="hasNoOverviewData(slotData.profile)">
                  <i class="bi bi-info-circle"></i>
                  <span>No additional profile details available for this lawyer yet.</span>
                </div>

              </div>
              <!-- /lawyer-overview-panel -->

              <!-- ══════════════ INTERNAL TAB: AVAILABLE SLOTS ══════════════ -->
              <ng-container *ngIf="lawyerInternalTab === 'slots' && !slotsLoading && !slotsError">

                <!-- No slots state -->
                <div class="slot-inline-state" *ngIf="slotData && dateTabs.length === 0">
                  <i class="bi bi-calendar-x"></i>
                  <span>No available slots at the moment. Please check back later.</span>
                </div>

                <!-- ── SLOT CONTENT (bookslot.component markup) ── -->
                <ng-container *ngIf="dateTabs.length > 0">

                  <!-- Appointment card — identical to bookslot.component .appointment-card -->
                  <div class="appointment-card">

                    <div class="slot-header-row">
                      <h3>Pick a Time Slot</h3>
                      <span class="slot-fee" *ngIf="slotData?.profile?.consultation_fee">
                        <span class="slot-fee-label">Consultation Fee</span>
                        <span class="slot-fee-amount">
                          {{ slotData.profile.consultation_fee.symbol || '₹' }}{{ slotData.profile.consultation_fee.amount }}
                        </span>
                      </span>
                    </div>

                    <!-- Date tabs with prev/next arrows -->
                    <div class="date-tabs-wrapper">
                      <button class="date-nav-btn date-nav-prev"
                              (click)="scrollDateTabs(-1)"
                              [class.hidden]="!canScrollLeft"
                              aria-label="Previous dates">
                        <i class="bi bi-chevron-left"></i>
                      </button>

                      <div class="date-tabs" #dateTabsScroll (scroll)="onDateTabsScroll()">
                        <div class="date"
                          *ngFor="let d of dateTabs"
                          [class.active]="selectedDateKey === d.date"
                          (click)="selectDateTab(d.date)">
                          {{ d.label }}
                          <span>{{ d.available_slots }} Slots Available</span>
                        </div>
                      </div>

                      <button class="date-nav-btn date-nav-next"
                              (click)="scrollDateTabs(1)"
                              [class.hidden]="!canScrollRight"
                              aria-label="Next dates">
                        <i class="bi bi-chevron-right"></i>
                      </button>
                    </div>

                    <!-- Slots — identical to bookslot.component .slots-container -->
                    <div class="slots-container">
                      <div *ngFor="let day of filteredSlots" class="day-block">

                        <!-- <h3 class="day-title">
                          {{ day.day_label }}
                          <small>({{
                            getAvailable(day.morning) + getAvailable(day.afternoon) +
                            getAvailable(day.evening) + getAvailable(day.night)
                          }} slots)</small>
                        </h3> -->

                        <div class="slot-section" *ngIf="day.morning?.length">
                          <h4>Morning <small>({{ getAvailable(day.morning) }} slots)</small></h4>
                          <div class="slots">
                            <button *ngFor="let s of day.morning"
                              [disabled]="!s.available"
                              (click)="checkoutSlot(day, s)">
                              {{ s.start_time }}
                            </button>
                          </div>
                        </div>

                        <div class="slot-section" *ngIf="day.afternoon?.length">
                          <h4>Afternoon <small>({{ getAvailable(day.afternoon) }} slots)</small></h4>
                          <div class="slots">
                            <button *ngFor="let s of day.afternoon"
                              [disabled]="!s.available"
                              (click)="checkoutSlot(day, s)">
                              {{ s.start_time }}
                            </button>
                          </div>
                        </div>

                        <div class="slot-section" *ngIf="day.evening?.length">
                          <h4>Evening <small>({{ getAvailable(day.evening) }} slots)</small></h4>
                          <div class="slots">
                            <button *ngFor="let s of day.evening"
                              [disabled]="!s.available"
                              (click)="checkoutSlot(day, s)">
                              {{ s.start_time }}
                            </button>
                          </div>
                        </div>

                        <div class="slot-section" *ngIf="day.night?.length">
                          <h4>Night <small>({{ getAvailable(day.night) }} slots)</small></h4>
                          <div class="slots">
                            <button *ngFor="let s of day.night"
                              [disabled]="!s.available"
                              (click)="checkoutSlot(day, s)">
                              {{ s.start_time }}
                            </button>
                          </div>
                        </div>

                      </div>
                      <!-- /day-block -->
                    </div>
                    <!-- /slots-container -->

                  </div>
                  <!-- /appointment-card -->

                </ng-container>
                <!-- /slot content -->

              </ng-container>
              <!-- /INTERNAL TAB: AVAILABLE SLOTS -->

            </div>
            <!-- /slot-expansion-wrapper -->

          </div>
          <!-- /firm-lawyer-card -->

        </ng-container>
      </div>
      <!-- /firm-lawyer-list -->

    </div>
    <!-- /Tab 2 -->

      </div><!-- /tab-content-area -->

      </div><!-- /tabs-content-card -->

    </div><!-- /fd-main-col -->

    <!-- ══════════════════════════════
         RIGHT COLUMN: info cards
         ══════════════════════════════ -->
    <div class="fd-side-col">

      <!-- Why choose Lex-Z? -->
      <div class="fd-info-card">
        <h4 class="fd-info-card-title">Why choose Lex-Z?
        </h4>
        <ul class="fd-info-card-list">
          <li>
            <span class="fd-info-item-icon"><i class="bi bi-person-check"></i></span>
            <div>
              <strong>Verified &amp; trusted professionals</strong>
              <p>All lawyers are verified by our team</p>
            </div>
          </li>
          <li>
            <span class="fd-info-item-icon"><i class="bi bi-shield-lock"></i></span>
            <div>
              <strong>Secure &amp; confidential</strong>
              <p>Your information is safe with us</p>
            </div>
          </li>
          <li>
            <span class="fd-info-item-icon"><i class="bi bi-calendar-check"></i></span>
            <div>
              <strong>Hassle-free booking</strong>
              <p>Book, pay and consult with ease</p>
            </div>
          </li>
        </ul>
      </div>

      <!-- What happens next? -->
      <div class="fd-info-card">
        <h4 class="fd-info-card-title"> What happens next?
        </h4>
        <ol class="fd-info-steps-list">
          <li>
            <span class="fd-step-num ">1</span>
            <div>
              <strong>You've viewed the firm details</strong>
              <p>Shortlisted and explore lawyer profiles</p>
            </div>
          </li>
          <li>
            <span class="fd-step-num fd-step-num--active">2</span>
            <div>
              <strong>Choose a lawyer &amp; book appointment</strong>
              <p>Select a lawyer that suits your needs</p>
            </div>
          </li>
          <li>
            <span class="fd-step-num">3</span>
            <div>
              <strong>Consult &amp; get legal help</strong>
              <p>Connect and discuss your case securely</p>
            </div>
          </li>
        </ol>
      </div>

      <!-- Visit Help Center -->
      <div class="fd-info-card fd-help-card">
        <div class="fd-help-card-body">
          <div class="fd-help-text">
            <strong>Have questions before booking?</strong>
            <p>Explore our resources or reach out to our support team.</p>
          </div>
           <a class="fd-help-btn" title="Contact Support" href="#" onclick="window.open('https://mail.google.com/mail/?view=cm&fs=1&to=support@lexiz.ai&su=Support%20Request', '_blank'); return false;">
            Visit Help Center &rarr;
          </a>
        </div>
      </div>

    </div><!-- /fd-side-col -->

  </div><!-- /fd-page-outer -->

</div>
<!-- /firm-details-page -->

<!-- ═══════════════════════════════════════════════════════════
     LOGIN / REGISTER MODAL — identical to bookslot.component
     ═══════════════════════════════════════════════════════════ -->
<div class="modal-overlay" *ngIf="showLoginModal" (click)="closeModalOnBackdrop($event)">
  <div class="modal-panel" role="dialog" aria-modal="true" aria-label="Login to continue">

    <button class="modal-close" (click)="closeLoginModal()" aria-label="Close">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M13.5 4.5L4.5 13.5M4.5 4.5L13.5 13.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>

    <!-- ═══════════════ VIEW: LOGIN / REGISTER ═══════════════ -->
    <ng-container *ngIf="modalView === 'login'">

      <div class="modal-header">
        <img src="assets/images/lex-z_logo.png" alt="Lex-Z" class="modal-logo" />
        <h2 class="modal-title">
          <ng-container *ngIf="otpSent">Enter OTP</ng-container>
          <ng-container *ngIf="!otpSent">
            {{ isRegisterMode ? 'Create your account' : 'Login into your account' }}
          </ng-container>
        </h2>
      </div>

      <div class="otp-sent-banner" *ngIf="otpSent && isRegisterMode">
        {{ otpSentMessage }}
      </div>
      <div class="otp-sent-banner" *ngIf="otpSent && !isRegisterMode">
        OTP sent to your {{ loginType === 'email' ? 'email' : 'mobile number' }}
      </div>

      <form [formGroup]="isRegisterMode ? registerForm : loginForm" class="modal-form"
            (ngSubmit)="isRegisterMode ? onRegisterButtonClicked() : onLoginButtonClicked()">

        <div *ngIf="!otpSent">

          <!-- REGISTER MODE: Name Fields -->
          <ng-container *ngIf="isRegisterMode">
            <div class="name-fields" style="display: flex; gap: 15px; margin-bottom: 15px;">
              <div class="modal-field" style="flex: 1; margin-bottom: 0;">
                <label>First Name</label>
                <input type="text" formControlName="firstName" placeholder="Enter your first name"
                  (input)="restricttextSpace($event)"
                  [class.field-error]="submitted && registerForm.get('firstName')?.errors">
                <div class="field-error-msg" *ngIf="submitted && registerForm.get('firstName')?.errors">
                  <span *ngIf="registerForm.get('firstName')?.errors?.['required']">First Name is required</span>
                </div>
              </div>
              <div class="modal-field" style="flex: 1; margin-bottom: 0;">
                <label>Last Name</label>
                <input type="text" formControlName="lastName" placeholder="Enter your last name"
                  (input)="restricttextSpace($event)"
                  [class.field-error]="submitted && registerForm.get('lastName')?.errors">
                <div class="field-error-msg" *ngIf="submitted && registerForm.get('lastName')?.errors">
                  <span *ngIf="registerForm.get('lastName')?.errors?.['required']">Last Name is required</span>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- REGISTER MODE: Email Field -->
          <div class="modal-field" *ngIf="isRegisterMode">
            <label>Email Address</label>
            <input
              type="email"
              formControlName="email"
              placeholder="Enter your email address"
              (input)="restricttextSpace($event)"
              [class.field-error]="submitted && registerForm.get('email')?.errors"
              autocomplete="off">
            <div class="field-error-msg" *ngIf="submitted && registerForm.get('email')?.errors">
              <span *ngIf="registerForm.get('email')?.errors?.['required']">Email address is required</span>
              <span *ngIf="registerForm.get('email')?.errors?.['invalidEmail']">Please enter a valid email address</span>
            </div>
          </div>

          <!-- REGISTER MODE: Mobile Number Field -->
          <div class="modal-field" *ngIf="isRegisterMode">
            <label>Mobile Number</label>
            <input
              type="text"
              inputmode="numeric"
              formControlName="mobile"
              placeholder="Enter your mobile number"
              (input)="onMobileInput($event)"
              [class.field-error]="submitted && registerForm.get('mobile')?.errors"
              autocomplete="off"
              maxlength="10">
            <div class="field-error-msg" *ngIf="submitted && registerForm.get('mobile')?.errors">
              <span *ngIf="registerForm.get('mobile')?.errors?.['required']">Mobile number is required</span>
              <span *ngIf="registerForm.get('mobile')?.errors?.['invalidMobile']">Please enter a valid phone number</span>
            </div>
          </div>

          <!-- LOGIN MODE: Email / Mobile -->
          <div class="modal-field" *ngIf="!isRegisterMode">
            <label>{{ useOTP ? 'Email or Mobile Number' : 'Email Address' }}</label>
            <input type="text" formControlName="emailOrMobile"
              [placeholder]="useOTP ? 'Enter email or mobile number' : 'Enter your email'"
              (input)="restricttextSpace($event)"
              [class.field-error]="submitted && f['emailOrMobile'].errors"
              autocomplete="username">
            <div class="field-error-msg" *ngIf="submitted && f['emailOrMobile'].errors">
              <span *ngIf="f['emailOrMobile'].errors?.['required']">
                {{ useOTP ? 'Email or mobile number is required' : 'Email is required' }}
              </span>
              <span *ngIf="f['emailOrMobile'].errors?.['invalidEmailOrMobile'] && useOTP">
                Please enter a valid email or mobile
              </span>
            </div>
          </div>

          <!-- Password Field (Login mode, password method) -->
          <div class="modal-field password-field" *ngIf="!useOTP && !isRegisterMode">
            <label>Password</label>
            <div class="password-input-wrap">
              <input
                [type]="hidePassword ? 'text' : 'password'"
                formControlName="password"
                placeholder="Enter your password"
                autocomplete="current-password"
                [class.field-error]="submitted && f['password'].errors">
              <button type="button" class="toggle-password" (click)="hidePassword = !hidePassword">
                <i class="bi" [class.bi-eye]="hidePassword" [class.bi-eye-slash]="!hidePassword"></i>
              </button>
            </div>
            <div class="field-error-msg" *ngIf="submitted && f['password'].errors">
              <span *ngIf="f['password'].errors?.['required']">Password is required</span>
            </div>
          </div>
        </div>

        <div class="modal-toggle-row" *ngIf="!otpSent">
          <label class="remember-me" *ngIf="!useOTP && !isRegisterMode">
            <input type="checkbox" formControlName="rememberMe">
            <span>Remember me</span>
          </label>
          <a href="javascript:void(0)"
            class="toggle-login-method"
            *ngIf="!isRegisterMode"
            (click)="toggleLoginMethod()">
            {{ useOTP ? 'Use Password Instead' : 'Use OTP Instead' }}
          </a>
        </div>

        <!-- Login OTP Block -->
        <div class="modal-field otp-field" *ngIf="useOTP && otpSent && !isRegisterMode">
          <label>Enter 6-digit OTP</label>
          <div class="otp-boxes">
            <input #otpInput type="text" class="otp-box" maxlength="1" inputmode="numeric"
              [(ngModel)]="otpDigits[0]" [ngModelOptions]="{standalone: true}"
              (input)="onOtpDigitInput($event, 0)" (keydown)="onOtpKeyDown($event, 0)"
              (paste)="onOtpPaste($event)" autocomplete="off">
            <input #otpInput type="text" class="otp-box" maxlength="1" inputmode="numeric"
              [(ngModel)]="otpDigits[1]" [ngModelOptions]="{standalone: true}"
              (input)="onOtpDigitInput($event, 1)" (keydown)="onOtpKeyDown($event, 1)" autocomplete="off">
            <input #otpInput type="text" class="otp-box" maxlength="1" inputmode="numeric"
              [(ngModel)]="otpDigits[2]" [ngModelOptions]="{standalone: true}"
              (input)="onOtpDigitInput($event, 2)" (keydown)="onOtpKeyDown($event, 2)" autocomplete="off">
            <input #otpInput type="text" class="otp-box" maxlength="1" inputmode="numeric"
              [(ngModel)]="otpDigits[3]" [ngModelOptions]="{standalone: true}"
              (input)="onOtpDigitInput($event, 3)" (keydown)="onOtpKeyDown($event, 3)" autocomplete="off">
            <input #otpInput type="text" class="otp-box" maxlength="1" inputmode="numeric"
              [(ngModel)]="otpDigits[4]" [ngModelOptions]="{standalone: true}"
              (input)="onOtpDigitInput($event, 4)" (keydown)="onOtpKeyDown($event, 4)" autocomplete="off">
            <input #otpInput type="text" class="otp-box" maxlength="1" inputmode="numeric"
              [(ngModel)]="otpDigits[5]" [ngModelOptions]="{standalone: true}"
              (input)="onOtpDigitInput($event, 5)" (keydown)="onOtpKeyDown($event, 5)" autocomplete="off">
          </div>
          <div class="field-error-msg" *ngIf="submitted && f['otp'].errors">
            <span *ngIf="f['otp'].errors?.['required']">OTP is required</span>
            <span *ngIf="f['otp'].errors?.['pattern']">OTP must be 6 digits</span>
          </div>
        </div>

        <!-- Register OTP Block -->
        <div class="modal-field otp-field" *ngIf="isRegisterMode && otpSent">
          <label>Enter OTP</label>
          <div class="otp-boxes">
            <input #otpInput type="text" class="otp-box" maxlength="1" inputmode="numeric"
              [(ngModel)]="otpDigits[0]" [ngModelOptions]="{standalone: true}"
              (input)="onOtpDigitInput($event, 0)" (keydown)="onOtpKeyDown($event, 0)"
              (paste)="onOtpPaste($event)" autocomplete="off">
            <input #otpInput type="text" class="otp-box" maxlength="1" inputmode="numeric"
              [(ngModel)]="otpDigits[1]" [ngModelOptions]="{standalone: true}"
              (input)="onOtpDigitInput($event, 1)" (keydown)="onOtpKeyDown($event, 1)" autocomplete="off">
            <input #otpInput type="text" class="otp-box" maxlength="1" inputmode="numeric"
              [(ngModel)]="otpDigits[2]" [ngModelOptions]="{standalone: true}"
              (input)="onOtpDigitInput($event, 2)" (keydown)="onOtpKeyDown($event, 2)" autocomplete="off">
            <input #otpInput type="text" class="otp-box" maxlength="1" inputmode="numeric"
              [(ngModel)]="otpDigits[3]" [ngModelOptions]="{standalone: true}"
              (input)="onOtpDigitInput($event, 3)" (keydown)="onOtpKeyDown($event, 3)" autocomplete="off">
            <input #otpInput type="text" class="otp-box" maxlength="1" inputmode="numeric"
              [(ngModel)]="otpDigits[4]" [ngModelOptions]="{standalone: true}"
              (input)="onOtpDigitInput($event, 4)" (keydown)="onOtpKeyDown($event, 4)" autocomplete="off">
            <input #otpInput type="text" class="otp-box" maxlength="1" inputmode="numeric"
              [(ngModel)]="otpDigits[5]" [ngModelOptions]="{standalone: true}"
              (input)="onOtpDigitInput($event, 5)" (keydown)="onOtpKeyDown($event, 5)" autocomplete="off">
          </div>
          <div class="field-error-msg" *ngIf="submitted && registerForm.get('otp')?.errors">
            <span *ngIf="registerForm.get('otp')?.errors?.['required']">OTP is required</span>
          </div>
        </div>

        <div class="modal-actions-row">
          <div class="resend-container" *ngIf="otpSent">
            <span *ngIf="!canResend" class="resend-timer">Resend in {{ resendTimer }}s</span>
            <a *ngIf="canResend" href="javascript:void(0)" class="resend-otp" (click)="resendOTP()">Resend OTP</a>
          </div>
        </div>

        <button type="submit" class="modal-login-btn">
          {{ otpSent ? 'Verify OTP' : (useOTP ? 'Send OTP' : 'Log In') }}
        </button>

        <button *ngIf="otpSent" type="button" class="modal-cancel-btn" (click)="cancelOTP()">Go Back</button>

        <!-- Forgot Password link — shown only in password mode before OTP stage -->
        <div *ngIf="!useOTP && !otpSent && !isRegisterMode" class="modal-forgot-row">
          <a href="javascript:void(0)" class="modal-forgot-link" (click)="goToForgotPassword()">Forgot Password?</a>
        </div>

        <div class="modal-footer-toggle" *ngIf="!otpSent" style="text-align: center; margin-top: 15px; font-size: 14px; color: #666;">
          <ng-container *ngIf="!isRegisterMode">
            Don't have an account?
            <a href="javascript:void(0)" class="register-link" (click)="isRegisterMode = true; showConfirmDialog = false; isLoginRedirectFlow = false; isExistingUser = false; otpSentMessage = ''"
               style="color: #007bff; font-weight: 500;">Register Here</a>
          </ng-container>
          <ng-container *ngIf="isRegisterMode">
            Already have an account?
            <a href="javascript:void(0)" class="register-link" (click)="isRegisterMode = false; showConfirmDialog = false; isLoginRedirectFlow = false; isExistingUser = false; otpSentMessage = ''"
               style="color: #007bff; font-weight: 500;">Log In</a>
          </ng-container>
        </div>

      </form>
    </ng-container>

    <!-- ═══════════════ VIEW: FORGOT PASSWORD ═══════════════ -->
    <ng-container *ngIf="modalView === 'forgot'">
      <div class="modal-header">
        <img src="assets/images/lex-z_logo.png" alt="Lex-Z" class="modal-logo" />
        <h2 class="modal-title">Forgot Password</h2>
      </div>

      <form [formGroup]="forgotPasswordForm" class="modal-form" (ngSubmit)="onForgotPasswordSubmit()">
        <p class="modal-info-text">Don't worry! Please enter the email address associated with your account.</p>

        <div class="modal-field">
          <label>Email Address</label>
          <input type="email" formControlName="email"
            placeholder="Enter your email address"
            (input)="restricttextSpace($event)"
            autocomplete="email"
            [class.field-error]="forgotSubmitted && forgotPasswordForm.get('email')?.errors">
          <div class="field-error-msg" *ngIf="forgotSubmitted && forgotPasswordForm.get('email')?.errors">
            <span *ngIf="forgotPasswordForm.get('email')?.errors?.['required']">Email is required</span>
            <span *ngIf="forgotPasswordForm.get('email')?.errors?.['email']">Please enter a valid email address</span>
          </div>
        </div>

        <button type="submit" class="modal-login-btn">Send Reset Token</button>

        <button type="button" class="modal-cancel-btn" (click)="modalView = 'login'">
          Back to Login
        </button>
      </form>
    </ng-container>

    <!-- ═══════════════ VIEW: RESET PASSWORD ═══════════════ -->
    <ng-container *ngIf="modalView === 'reset'">
      <div class="modal-header">
        <img src="assets/images/lex-z_logo.png" alt="Lex-Z" class="modal-logo" />
        <h2 class="modal-title">Reset Password</h2>
      </div>

      <form [formGroup]="resetPasswordForm" class="modal-form" (ngSubmit)="onResetPasswordSubmit()">
        <p class="modal-info-text">
          A password reset token was sent to <strong>{{ resetMail }}</strong>. Enter it below along with your new password.
        </p>

        <!-- Token -->
        <div class="modal-field">
          <label>Reset Token</label>
          <input type="text" formControlName="token"
            placeholder="Enter the token from your email"
            (input)="restricttextSpace($event)"
            autocomplete="off"
            [class.field-error]="resetSubmitted && rf['token'].errors">
          <div class="field-error-msg" *ngIf="resetSubmitted && rf['token'].errors">
            <span *ngIf="rf['token'].errors?.['required']">Token is required</span>
          </div>
        </div>

        <!-- New Password -->
        <div class="modal-field password-field">
          <label>New Password</label>
          <div class="password-input-wrap">
            <input
              [type]="hideResetPassword ? 'text' : 'password'"
              formControlName="password"
              placeholder="Enter new password"
              autocomplete="new-password"
              [class.field-error]="resetSubmitted && rf['password'].errors">
            <button type="button" class="toggle-password" (click)="hideResetPassword = !hideResetPassword">
              <i class="bi" [class.bi-eye]="hideResetPassword" [class.bi-eye-slash]="!hideResetPassword"></i>
            </button>
          </div>
          <div class="field-error-msg" *ngIf="resetSubmitted && rf['password'].errors">
            <span *ngIf="rf['password'].errors?.['required']">Password is required</span>
            <span *ngIf="rf['password'].errors?.['minlength']">Password must be at least 8 characters</span>
          </div>
        </div>

        <!-- Confirm Password -->
        <div class="modal-field password-field">
          <label>Confirm Password</label>
          <div class="password-input-wrap">
            <input
              [type]="hideConfirmPassword ? 'text' : 'password'"
              formControlName="confirmPassword"
              placeholder="Confirm new password"
              autocomplete="new-password"
              [class.field-error]="resetSubmitted && (rf['confirmPassword'].errors || resetPasswordForm.errors?.['notSame'])">
            <button type="button" class="toggle-password" (click)="hideConfirmPassword = !hideConfirmPassword">
              <i class="bi" [class.bi-eye]="hideConfirmPassword" [class.bi-eye-slash]="!hideConfirmPassword"></i>
            </button>
          </div>
          <div class="field-error-msg" *ngIf="resetSubmitted && resetPasswordForm.errors?.['notSame']">
            <span>Passwords do not match</span>
          </div>
        </div>

        <div class="modal-resend-row">
          Didn't receive the token?
          <a href="javascript:void(0)" class="resend-otp" (click)="resendResetToken()">Resend Token</a>
        </div>

        <button type="submit" class="modal-login-btn">Update Password</button>

        <button type="button" class="modal-cancel-btn" (click)="modalView = 'forgot'">Back</button>
      </form>
    </ng-container>

  </div>
</div>

<!-- ========== Register Confirmation Dialog ========== -->
<div class="register-confirm-overlay" *ngIf="showConfirmDialog" (click)="$event.stopPropagation()">
  <div class="register-confirm-dialog" role="dialog" aria-modal="true" aria-labelledby="registerConfirmDialogTitle">
    <h3 class="register-confirm-title" id="registerConfirmDialogTitle">Confirm Details</h3>
    <p class="register-confirm-message">
      Please confirm your email address <strong>{{ confirmEmail }}</strong> and phone number <strong>{{ confirmPhone }}</strong>.
    </p>
    <div class="register-confirm-actions">
      <button type="button" class="register-confirm-btn-secondary" (click)="onRegisterConfirmCancel()">
        No, Edit
      </button>
      <button type="button" class="register-confirm-btn-primary" (click)="onRegisterConfirmProceed()">
        Yes, Continue
      </button>
    </div>
  </div>
</div>

<!-- Footer -->
<footer>
  <div class="footer-container">
    <div class="footer-bottom">
      <a  alt="terms of service"
            href="https://digicoffer.com/digicoffer_terms.pdf">Terms of Service</a>
      <span>|</span>
      <a alt="privacy policy" href="https://digicoffer.com/digicoffer_privacy.pdf">Privacy Policy</a>
      <span>|</span>
      <a href="https://digicoffer.com/digicoffer_cookie.pdf">Cookie Policy</a>
    </div>
    <div class="footer-credit">© {{ currentYear }} Lex-Z. All rights reserved.</div>
  </div>
</footer>